import { RootState } from 'theSource/app/store';

export const selectEnrollmentLatest = (state: RootState) => {
  return state.enrollment.enrollmentStatus.enrollmentLatest;
};

export const selectTotalSubNavItems = (state: RootState) =>
  state.enrollment.enrollmentStatus.totalSubNavItems;

export const selectCurrentSubNavItem = (state: RootState) =>
  state.enrollment.enrollmentStatus.currentSubNavItem;

export const selectMaxSubNavItem = (state: RootState) =>
  state.enrollment.enrollmentStatus.maxSubNavItem;

export const selectProfileSteps = (state: RootState) =>
  state.enrollment.enrollmentStatus.profileSteps;
